<template>
  <div class="silly-token-container">
    <!-- Search and Action Section -->
    <div style="display: flex; align-items: center; margin-bottom: 15px;">
      <div>
        <el-input
            v-model="searchForm.token"
            placeholder="搜索Token值"
            clearable
            size="small"
            @clear="handleClear('token')"
            @input="handleSearch">
        </el-input>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="fetchTokens">查询</el-button>
      </div>
      <div style="padding-right: 10px">
        <el-button type="warning" size="small" @click="generateTokens">批量生成Token</el-button>
      </div>
      <div>
        <el-checkbox v-model="searchForm.queryAll" @change="handleQueryAllChange">查询全部</el-checkbox>
      </div>
    </div>

    <!-- Table Section -->
    <el-table
        :data="tokens"
        border
        style="width: 100%">
      <el-table-column
          type="index"
          label="序号"
          width="60">
      </el-table-column>
      <el-table-column
          prop="token"
          label="Token值"
          width="300">
        <template slot-scope="scope">
          {{ scope.row.token }}
          <el-button
              size="mini"
              type="text"
              @click="copyToClipboard(scope.row.token)"
              @touchstart="copyToClipboard(scope.row.token)">
            复制
          </el-button>
        </template>
      </el-table-column>
      <!-- Removed the price/渠道 column as requested -->
      <el-table-column
          prop="points"
          label="积分"
          width="80">
      </el-table-column>
      <el-table-column
          prop="status"
          label="使用状态"
          width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : 'info'">
            {{ scope.row.status === 0 ? '未使用' : '已使用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="isDisabled"
          label="是否禁用"
          width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isDisabled === 0 ? 'success' : 'danger'">
            {{ scope.row.isDisabled === 0 ? '未禁用' : '已禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="expireTime"
          label="过期时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.expireTime) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="创建时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="150">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Edit Dialog -->
    <el-dialog title="编辑Token" :visible.sync="editDialogVisible" width="30%" @close="resetEditForm">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="Token值" :rules="{ required: true, message: 'Token值不能为空', trigger: 'blur' }">
          <el-input v-model="editForm.token"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="editForm.type" placeholder="请输入类型"></el-input>
        </el-form-item>
        <el-form-item label="渠道">
          <el-input v-model="editForm.price" placeholder="请输入渠道"></el-input>
        </el-form-item>
        <el-form-item label="积分">
          <el-input
              v-model.number="editForm.points"
              type="number"
              placeholder="请输入积分"
              :min="0">
          </el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker
              v-model="editForm.expireTime"
              type="datetime"
              placeholder="选择过期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option label="未使用" :value="0"></el-option>
            <el-option label="已使用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否禁用">
          <el-select v-model="editForm.isDisabled" placeholder="请选择是否禁用">
            <el-option label="未禁用" :value="0"></el-option>
            <el-option label="已禁用" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditForm('editForm')">确定</el-button>
      </span>
    </el-dialog>

    <!-- Pagination Section -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalTokens">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';
import { Message } from 'element-ui';

export default {
  data() {
    return {
      editDialogVisible: false,
      editForm: {
        id: null,
        token: '',
        type: '',
        price: '',
        points: 0,
        expireTime: null,
        status: 0,
        isDisabled: 0
      },
      searchForm: {
        token: '',
        queryAll: false
      },
      tokens: [],
      totalTokens: 0,
      currentPage: 1,
      pageSize: 10,
      isGenerating: false
    };
  },
  methods: {
    async fetchTokens() {
      try {
        const requestData = {
          current: this.currentPage,
          size: this.pageSize,
          token: this.searchForm.token
        };

        // If not querying all, only show unused and not disabled tokens
        if (!this.searchForm.queryAll) {
          requestData.status = 0;  // 未使用
          requestData.isDisabled = 0;  // 未禁用
        }

        const response = await axios.post(`/api/admin/silly/tokens/page`, requestData, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200 && response.data.data) {
          this.tokens = response.data.data.records || [];
          this.totalTokens = response.data.data.total || 0;
        } else {
          this.tokens = [];
          this.totalTokens = 0;
          Message.error(response.data.msg || '获取数据失败');
        }
      } catch (error) {
        Message.error('获取Tokens失败: ' + error.message);
        this.tokens = [];
        this.totalTokens = 0;
      }
    },
    handleQueryAllChange() {
      this.currentPage = 1; // Reset to first page when changing query type
      this.fetchTokens();
    },
    handleSearch() {
      this.currentPage = 1; // Reset to first page when searching
      this.fetchTokens();
    },
    handleClear(attribute) {
      this.searchForm[attribute] = '';
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchTokens();
    },
    formatDate(date) {
      if (!date) return '';

      // 处理数组格式 [year, month, day, hour, minute, second]
      if (Array.isArray(date)) {
        const [year, month, day, hour, minute, second] = date;
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
      }

      // 处理常规日期字符串
      try {
        return new Date(date).toLocaleString();
      } catch (error) {
        console.error('Date formatting error:', error);
        return '';
      }
    },
    resetEditForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
    },
    async submitEditForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const formData = { ...this.editForm };

            // 将日期对象转换为后端期望的格式
            if (formData.expireTime && formData.expireTime instanceof Date) {
              // 创建年月日时分秒的数组
              formData.expireTime = [
                formData.expireTime.getFullYear(),
                formData.expireTime.getMonth() + 1, // 月份需要加1，因为JS中月份从0开始
                formData.expireTime.getDate(),
                formData.expireTime.getHours(),
                formData.expireTime.getMinutes(),
                formData.expireTime.getSeconds()
              ];
            }

            const response = await axios.put('/api/admin/silly/tokens', formData, {
              headers: {
                'token': this.$cookies.get('token'),
                'Content-Type': 'application/json'
              }
            });

            if (response.data.code === 200) {
              this.$message({
                type: 'success',
                message: 'Token更新成功!'
              });
              this.editDialogVisible = false;
              await this.fetchTokens();
            } else {
              this.$message.error(response.data.msg || '更新失败');
            }
          } catch (error) {
            this.$message.error('更新Token时发生错误: ' + error.message);
          }
        } else {
          return false;
        }
      });
    },
    handleEdit(row) {
      // 创建一个基本的editForm对象，不包含日期
      this.editForm = {
        id: row.id,
        token: row.token,
        type: row.type,
        price: row.price,
        points: row.points,
        status: row.status,
        isDisabled: row.isDisabled,
        expireTime: null
      };

      // 如果有过期时间数组，转换为日期对象
      if (row.expireTime && Array.isArray(row.expireTime) && row.expireTime.length >= 6) {
        const [year, month, day, hour, minute, second] = row.expireTime;
        // 注意：JavaScript Date中月份是从0开始的
        this.editForm.expireTime = new Date(year, month - 1, day, hour, minute, second);
      }

      this.editDialogVisible = true;
    },
    async handleDelete(row) {
      this.$confirm('确认删除该Token?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await axios.delete(`/api/admin/silly/tokens/${row.id}`, {
            headers: {
              'token': this.$cookies.get('token')
            }
          });

          if (response.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            await this.fetchTokens();
          } else {
            this.$message.error(response.data.msg || '删除失败');
          }
        } catch (error) {
          this.$message.error('删除Token时发生错误: ' + error.message);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    copyToClipboard(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message({
        message: 'Token已复制到剪贴板',
        type: 'success',
        duration: 1500
      });
    },
    async generateTokens() {
      if (this.isGenerating) {
        this.$message.warning('正在生成中，请稍候...');
        return;
      }

      this.$confirm('确认批量生成Token?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.isGenerating = true;
        const loading = this.$loading({
          lock: true,
          text: '正在生成Token，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
          const response = await axios.post('/api/admin/silly/tokens/generate', {}, {
            headers: {
              'token': this.$cookies.get('token'),
              'Content-Type': 'application/json'
            }
          });

          if (response.data.code === 200) {
            const count = response.data.data || '批量';
            this.$message({
              type: 'success',
              message: `成功生成${count}个Token!`
            });
            await this.fetchTokens();
          } else {
            this.$message.error(response.data.msg || '生成失败');
          }
        } catch (error) {
          this.$message.error('生成Token时发生错误: ' + error.message);
        } finally {
          loading.close();
          this.isGenerating = false;
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消生成'
        });
      });
    }
  },
  mounted() {
    this.fetchTokens();
  }
};
</script>

<style scoped>
.silly-token-container {
  padding: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>

